import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarOff } from 'lucide-react';
import { getOnLeaveToday } from '../../../services/dashboardService';
import { Card, CardHeader, CardTitle, CardBadge, ListItem, Avatar, ListItemContent, ListItemName, ListItemSub, EmptyState, ScrollList } from '../styles';
import { formatDate } from '../../../utils/Utils';

export default function OnLeaveTodayCard() {
  const { t, i18n } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    getOnLeaveToday().then(res => {
      const d = res.data?.data;
      setItems(Array.isArray(d) ? d : []);
    });
  }, []);

  return (
    <Card $delay="0.2s">
      <CardHeader>
        <CardTitle>{t('dashboard.onLeaveTodayTitle')}</CardTitle>
        {items.length > 0 && <CardBadge $bg="#FEE2E2" $color="#E53935">{items.length}</CardBadge>}
      </CardHeader>
      {items.length === 0 ? (
        <EmptyState>
          <CalendarOff size={32} />
          {t('dashboard.noOnLeave')}
        </EmptyState>
      ) : (
        <ScrollList>
          {items.map((item, i) => {
            const initials = item.fullName?.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
            return (
              <ListItem key={`${item.userId}-${i}`}>
                <Avatar $bg="linear-gradient(135deg, #FF6B6B, #E53935)">
                  {item.profilePicture ? <img src={item.profilePicture} alt="" /> : initials}
                </Avatar>
                <ListItemContent>
                  <ListItemName>{item.fullName}</ListItemName>
                  {/* KVKK — izin TÜRÜ yalnız izin yöneticisine ve kişinin kendisine gelir (sağlık
                      verisini ele verebilir); diğerleri yalnız "İzinli" görür. */}
                  <ListItemSub>{item.leaveVariationName || t('pdks.legendLeave')} - {formatDate(item.leaveEnd, i18n.language)}</ListItemSub>
                </ListItemContent>
              </ListItem>
            );
          })}
        </ScrollList>
      )}
    </Card>
  );
}
